import { useContext, useState } from "react";
import { Formik, Form, Field } from "formik";
import Input from "../../_local/components/Input/index";
import ImageUpload from "../../_local/components/ImageUpload/index";
import FormWrapper from "../../_local/components/FormWrapper/index";
import ResetAndSubmit from "../../_local/components/ResetAndSubmit/index";
import * as Yup from "yup";
import { AppContext, useGlobalState } from "../../_local/state/index";
import axios from "axios";
import { showGlobalModal as showOldOnboardingGlobalModal } from "../../_local/components/GlobalModal/index";
import { Img } from "../../_local/components/index";
import { API_CONSTANT_ONBOARDING } from "../../_local/utils/index";

// const trustSchema = Yup.object().shape({
//     //   type: Yup.string().oneOf(['trust']).required(),
//     TRUST_NAME: Yup.string().required('Trust name is required'),
//     TRUST_REGISTRATION_NUMBER: Yup.string().required('Trust registration number is required'),
//     // TRUST_BY_LAW: Yup.mixed().required('Trust deed is required'),
//     // TRUST_PAN: Yup.mixed().required('PAN is required'),
//     // CANCELLED_CHEQUE: Yup.mixed().required('Cancelled cheque is required'),
//     // AUTH_SIGN: Yup.mixed().required('Authorised signature is required'),
//     // REGISTRATION_CERTIFICATE: Yup.mixed().required('Registration certificate is required'),
// });

// const societySchema = Yup.object().shape({
//     //   type: Yup.string().oneOf(['society']).required(),
//     SOCIETY_NAME: Yup.string().required('Society name is required'),
//     SOCIETY_REGISTRATION_NUMBER: Yup.string().required('Society registration number is required'),
//     // SOCIETY_BY_LAW: Yup.mixed().required('Society law/deed certificate is required'),
//     // SCHOOL_REGISTRACTION_NUMBER: Yup.string().required('School registration number is required'),
//     // CANCELLED_CHEQUE: Yup.mixed().required('Cancelled cheque is required'),
//     // AUTH_SIGN: Yup.mixed().required('Authorised signature is required'),
//     // REGISTRATION_CERTIFICATE: Yup.mixed().required('Registration certificate is required'),
//     // SOCIETY_PAN: Yup.mixed().required('PAN is required'),
// });

// const validationSchema = (type) => {
//     return type === 'SOCIETY' ? societySchema : trustSchema;
// };

const NewAutoFeeHub = ({ handleNavigate, resetFormData, disableForm }: { handleNavigate, resetFormData?: any, titleAndDesNotRequired?: boolean, disableForm?: boolean }) => {
    const { instData } = useGlobalState();
    const [state, setState] = useState("SOCIETY");
    const [loader, setLoader] = useState(false);
    const emptyAutoFeeHubData = {
        SOCIETY: {
            SOCIETY_NAME: "",
            SOCIETY_REGISTRATION_NUMBER: "",
            SOCIETY_BY_LAW: "",
            SCHOOL_REGISTRACTION_NUMBER: "",
            CANCELLED_CHEQUE: "",
            AUTH_SIGN: "",
            REGISTRATION_CERTIFICATE: "",
            SOCIETY_PAN: "",
        },
        TRUST: {
            TRUST_NAME: "",
            TRUST_REGISTRATION_NUMBER: "",
            TRUST_BY_LAW: "",
            TRUST_PAN: "",
            CANCELLED_CHEQUE: "",
            AUTH_SIGN: "",
            REGISTRATION_CERTIFICATE: "",
        }
    };

    function validateForm(formData) {
        if (state === "SOCIETY") {
            const { SOCIETY_NAME, SOCIETY_REGISTRATION_NUMBER } = formData?.SOCIETY;
            return (SOCIETY_NAME?.trim() === "" || SOCIETY_REGISTRATION_NUMBER?.trim() === "");
        } else if (state === "TRUST") {
            const { TRUST_NAME, TRUST_REGISTRATION_NUMBER } = formData?.TRUST;
            return (TRUST_NAME?.trim() === "" || TRUST_REGISTRATION_NUMBER?.trim() === "");
        } else {
            return false; // Invalid type
        }
    }

    return <Formik
        initialValues={{ ...(Boolean(JSON.parse(sessionStorage.getItem("autoFeeHub"))) ? JSON.parse(sessionStorage.getItem("autoFeeHub")) || {} : emptyAutoFeeHubData) }}
        enableReinitialize
        // validationSchema={() => validationSchema(state)}
        onSubmit={async (values) => {
            try {
                setLoader(true)
                sessionStorage.setItem("autoFeeHub", JSON.stringify({ type: state, ...values }));
                const payload = {
                    // "BRANCH_FEE_GATEWAY_DETAIL_ID": 0,
                    "BRANCH_ID": instData?.BRANCH_ID,
                    "ENTITY_TYPE": state,
                    "NAME": (values?.[state]?.SOCIETY_NAME || values?.[state]?.TRUST_NAME),
                    "REGISTRATION_NUMBER": (values?.[state]?.SOCIETY_REGISTRATION_NUMBER || values?.[state]?.TRUST_REGISTRATION_NUMBER),
                    "BY_LAW_DEED_URL": (values?.[state]?.SOCIETY_BY_LAW || values?.[state]?.TRUST_BY_LAW)?.selectedImage,
                    "PAN_URL": (values?.[state]?.SOCIETY_PAN || values?.[state]?.TRUST_PAN)?.selectedImage,
                    "CANCELLED_CHEQUE_URL": (values?.[state]?.CANCELLED_CHEQUE)?.selectedImage,
                    "AUTHORIZED_SIGNATORY_URL": (values?.[state]?.AUTH_SIGN)?.selectedImage,
                    "INSTITUTE_REGISTRATION_URL": (values?.[state]?.REGISTRATION_CERTIFICATE)?.selectedImage,
                    "SCHOOL_REGISTRATION_URL": (values?.[state]?.SOCIETY_REGISTRATION_NUMBER)?.selectedImage,
                    // "IS_VERIFIED": false
                }
                const response = await axios.post(`${API_CONSTANT_ONBOARDING}/data/branchFeeGatewayDetail/upsert`, payload, {
                    headers: {
                        database: instData?.DATABASE_NAME,
                        "branch-id": instData?.BRANCH_ID,
                        "institute-id": instData?.INSTITUTE_ID,
                    }
                });
                if ([200, 201].includes(+response?.data?.code)) {
                    handleNavigate(false, "/old/onboarding/socialHubInfo");
                } else {
                    showOldOnboardingGlobalModal(response?.data?.message, "warning")
                }
            } catch (err) {
                showOldOnboardingGlobalModal(err.message, "error")
            } finally {
                setLoader(false);
            }
        }}
    >
        {({ values, handleSubmit, resetForm, errors, setFieldValue }) => <FormWrapper
            childern={
                <Form onSubmit={handleSubmit}>
                    <div className="font-manrope grid grid-cols-12 gap-6">
                        {/* {console.log("values ", values)}
                        {console.log("state ", values?.[state])}
                        {console.log("errors ", errors)} */}
                        <div className="col-span-5 space-y-2">
                            <h2 className="text-[2.5vh] font-manropeB">Automate your fee collection process.</h2>
                            <p className="text-[2vh] text-gray-500">To enable online fee payments, we need a few documents for <br />verification. <span className="font-manropeB">This process is secure and required by RBI guidelines.</span></p>
                        </div>
                        {/* <div className="col-span-7">
                            <div className="grid grid-cols-3 gap-4">
                                {[1, 2, 3].map((_, index) => <div key={"aslndjkasdjasdbkahgsdasd" + index} className="bg-[#F5F5F5] rounded-xl grid grid-cols-2 p-2">
                                    <p className="text-[2vh] font-manropeB">Feature {index + 1}</p>
                                    <div className="bg-[lightgray] rounded-xl w-full h-[8vh]"></div>
                                </div>)}
                            </div>
                        </div> */}
                        <div className="font-manropeB col-span-12 flex justify-center">
                            <div className="grid grid-cols-2 items-center bg-[#F5F5F5] border border-[#CCCCCC] rounded-full p-1 w-fit">
                                <button type="button" onClick={() => setState("SOCIETY")} className={`text-[2vh] w-full ${state === "SOCIETY" ? "bg-purple-primary text-[white]" : ""} rounded-full py-[1vh] px-8`}>
                                    Society
                                </button>
                                <button type="button" onClick={() => setState("TRUST")} className={`text-[2vh] w-full ${state === "TRUST" ? "bg-purple-primary text-[white]" : ""} rounded-full py-[1vh] px-8`}>
                                    Trust
                                </button>
                            </div>
                        </div>
                        {state === "SOCIETY" ? <>
                            <div className="col-span-6">
                                <Input
                                    disable={disableForm}
                                    label="Society Name"
                                    name={`${state}.SOCIETY_NAME`}
                                    type="text"
                                    placeHolder="Enter name of the institute"
                                    required
                                />
                            </div>
                            <div className="col-span-6">
                                <Input
                                    disable={disableForm}
                                    label="Society Registration Number"
                                    name={`${state}.SOCIETY_REGISTRATION_NUMBER`}
                                    type="text"
                                    placeHolder="Enter society registration number"
                                    required
                                />
                            </div>
                            <div className="col-span-4">
                                <Field name={`${state}.SOCIETY_BY_LAW`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.SOCIETY_BY_LAW}
                                            disable={disableForm}
                                            label="Society by law/deed"
                                            placeHolder="Upload society by Law/Deed certificate"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.SOCIETY_BY_LAW`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                            <div className="col-span-4">
                                <Field name={`${state}.SOCIETY_PAN`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.SOCIETY_PAN}
                                            disable={disableForm}
                                            label="Society PAN"
                                            placeHolder="Upload PAN"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.SOCIETY_PAN`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                            <div className="col-span-4">
                                <Field name={`${state}.SCHOOL_REGISTRACTION_NUMBER`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.SCHOOL_REGISTRACTION_NUMBER}
                                            disable={disableForm}
                                            label="School Registration Number"
                                            placeHolder="Upload school registration number"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.SCHOOL_REGISTRACTION_NUMBER`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                            <div className="col-span-4">
                                <Field name={`${state}.CANCELLED_CHEQUE`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.CANCELLED_CHEQUE}
                                            disable={disableForm}
                                            label="Cancelled cheque"
                                            placeHolder="Upload cancelled cheque"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.CANCELLED_CHEQUE`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                            <div className="col-span-4">
                                <Field name={`${state}.AUTH_SIGN`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.AUTH_SIGN}
                                            disable={disableForm}
                                            label="Authorised signature ( PAN/DL/Passport/voter ID)"
                                            placeHolder="Upload authorised signature"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.AUTH_SIGN`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                            <div className="col-span-4">
                                <Field name={`${state}.REGISTRATION_CERTIFICATE`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.REGISTRATION_CERTIFICATE}
                                            disable={disableForm}
                                            label="Upload Registration Certificate Of Your Institute"
                                            placeHolder="Upload registration certificate"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.REGISTRATION_CERTIFICATE`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                        </> : <>
                            <div className="col-span-6">
                                <Input
                                    disable={disableForm}
                                    label="Trust Name"
                                    name={`${state}.TRUST_NAME`}
                                    type="text"
                                    placeHolder="Enter name of the institute"
                                    required
                                />
                            </div>
                            <div className="col-span-6">
                                <Input
                                    disable={disableForm}
                                    label="Trust Registration Number"
                                    name={`${state}.TRUST_REGISTRATION_NUMBER`}
                                    type="text"
                                    placeHolder="Enter trust registration number"
                                    required
                                />
                            </div>
                            <div className="col-span-6">
                                <Field name={`${state}.TRUST_BY_LAW`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.TRUST_BY_LAW}
                                            disable={disableForm}
                                            label="Trust deed"
                                            placeHolder="Upload trust by Law/Deed certificate"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.TRUST_BY_LAW`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                            <div className="col-span-6">
                                <Field name={`${state}.TRUST_PAN`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.TRUST_PAN}
                                            disable={disableForm}
                                            label="Society PAN"
                                            placeHolder="Upload PAN"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.TRUST_PAN`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                            <div className="col-span-4">
                                <Field name={`${state}.CANCELLED_CHEQUE`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.CANCELLED_CHEQUE}
                                            disable={disableForm}
                                            label="Cancelled cheque"
                                            placeHolder="Upload cancelled cheque"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.CANCELLED_CHEQUE`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                            <div className="col-span-4">
                                <Field name={`${state}.AUTH_SIGN`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.AUTH_SIGN}
                                            disable={disableForm}
                                            label="Authorised signature ( PAN/DL/Passport/voter ID)"
                                            placeHolder="Upload authorised signature"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.AUTH_SIGN`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                            <div className="col-span-4">
                                <Field name={`${state}.REGISTRATION_CERTIFICATE`}>
                                    {({ field, form }) => (
                                        <ImageUpload
                                            customMessage={"JPG, JPEG or PDF (50 MB)"}
                                            allow="application/pdf"
                                            labledDesign
                                            // isError={!!values?.[state]?.REGISTRATION_CERTIFICATE}
                                            disable={disableForm}
                                            label="Upload Registration Certificate Of Your Institute"
                                            placeHolder="Upload registration certificate"
                                            maxSize={5}
                                            labelClassNames="text-[2vh]"
                                            containerHeight={{
                                                width: "7vh",
                                                height: "7vh",
                                            }}
                                            imageValue={field.value}
                                            onChange={(item) => {
                                                form.setFieldValue(`${state}.REGISTRATION_CERTIFICATE`, item);
                                            }}
                                        />
                                    )}
                                </Field>
                            </div>
                        </>}
                    </div>
                    <div className="flex justify-center mt-[4vh]">
                        <p className="text-[2vh] bg-gray-200 p-2 rounded-lg text-[black]"><span className="font-manropeB">Note:</span>  All documents should be self attested/self signed</p>
                    </div>
                    {!disableForm && <div className="flex justify-end my-2">
                        {loader ? (
                            <Img
                                src={"/images/loader.gif"}
                                className="w-10 h-10"
                                alt="Loading"
                            />
                        ) : (
                            <ResetAndSubmit
                                skipButtonAndFunction={() => {
                                    handleNavigate(false, "/old/onboarding/socialHubInfo");
                                }}
                                submitToolTip={validateForm(values) ? "Please fill in all the required fields." : ""}
                                isError={validateForm(values)}
                                resetForm={() => {
                                    resetForm();
                                    resetFormData();
                                }}
                            />
                        )}
                    </div>}
                </Form>}
        />}
    </Formik>
};

export default NewAutoFeeHub;
